import { render } from "./PanelGroup.vue?vue&type=template&id=d896df72&scoped=true"
import script from "./PanelGroup.vue?vue&type=script&lang=js"
export * from "./PanelGroup.vue?vue&type=script&lang=js"

import "./PanelGroup.vue?vue&type=style&index=0&id=d896df72&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d896df72"

export default script